import React from "react";
import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import CardActionableButton from "../../_utils/CommonViewAllCard/CardSubComponent/CardActionableButton";
import SVGComponent from "../../_utils/SVGComponent";
import IconIndicator from "../../_utils/IconIndicator";

const amountRegex =
  /((?:₹\s?\d[\d,]*(?:\.\d+)?|(?:INR|Rs\.?)\s?\d[\d,]*(?:\.\d+)?|\d[\d,]*(?:\.\d+)?\s?(?:INR|Rs\.?)))/gi;

const isNotificationRead = (notification) =>
  notification?.read === true || notification?.read === "true";

const normalizeAmountToken = (token = "") => {
  const numericPart =
    token.match(/\d[\d,]*(?:\.\d+)?/)?.[GlobalConfiguration.lengthCheckZero] ||
    "";
  const formattedNumber = numericPart
    ? Number(numericPart.replace(/,/g, "")).toLocaleString("en-IN", {
        minimumFractionDigits: numericPart.includes(".")
          ? numericPart.split(".")[GlobalConfiguration.lengthCheckOne].length
          : GlobalConfiguration.lengthCheckZero,
        maximumFractionDigits: numericPart.includes(".")
          ? numericPart.split(".")[GlobalConfiguration.lengthCheckOne].length
          : GlobalConfiguration.lengthCheckZero,
      })
    : "";

  if (!formattedNumber) return token;

  return token
    .replace(/\d[\d,]*(?:\.\d+)?/, formattedNumber)
    .replace(/₹\s*/g, "₹ ")
    .replace(/\bRs\.?\s*/gi, "Rs. ");
};

const isAmount = (value = "") => {
  amountRegex.lastIndex = GlobalConfiguration.lengthCheckZero;
  return amountRegex.test(value);
};

const renderDescription = (value) => {
  if (typeof value !== "string") return value;

  return value.split(amountRegex).map((part, index) =>
    isAmount(part) ? (
      <span
        key={`${part}-${index}`}
        className="font-semibold text-settled"
      >
        {normalizeAmountToken(part)}
      </span>
    ) : (
      <React.Fragment key={`${part}-${index}`}>{part}</React.Fragment>
    ),
  );
};

const NotificationPopupCard = ({
  notification,
  canUseNotifyService,
  onSnooze,
  onFavourite,
  onViewLinkedItem,
  isAnimating,
}) => {
  const isRead = isNotificationRead(notification);

  return (
    <div
      className={`rounded-border-radius-sm bg-primary-card px-padding-md global-hover-white relative cursor-pointer py-padding-sm z-z-index-base overflow-hidden ${
        isRead ? "bg-opacity-light-opacity" : ""
      } ${isAnimating ? "animate-slideOutFromRight" : ""}`}
      onClick={() => onViewLinkedItem?.(notification)}
    >
      <div>
        <div className="relative z-z-index-max flex justify-between items-center gap-gap-sm">
          {isRead ? null : <IconIndicator bgColor={"var(--settled)"} />}
          <p
            className={`flex-1 min-w-min-width-base text-text-primary text-font-sm ${isRead ? "font-normal" : "font-semibold"} break-words`}
          >
            {renderDescription(notification?.title || "No message available")}
          </p>

          <div className="flex items-center gap-gap-sm shrink-0">
            <CardActionableButton
              handleFunction={() => onSnooze?.(notification)}
              isDisabled={!canUseNotifyService}
              bgColor="var(--primary-nav)"
              icon={ICONS.SNOOZE}
              hoverOption="white"
              title="snooze"
              imgColor="var(--text-primary)"
            />
            <CardActionableButton
              handleFunction={() => onFavourite?.(notification)}
              isDisabled={!canUseNotifyService}
              bgColor="var(--primary-nav)"
              icon={
                notification?.favourite === true
                  ? ICONS.FAVOURITE_FILLED
                  : ICONS.FAVOURITE
              }
              hoverOption="white"
              title="favourite"
            />
          </div>
        </div>
        <div
          className={`${isRead ? "text-text-secondary" : "text-text-primary"} text-font-xs font-normal w-width-almost-full pt-padding-xs`}
        >
          {notification?.message}
        </div>
      </div>
      <div className="relative z-z-index-max flex Qssm:items-center items-start justify-between pt-padding-md gap-gap-sm Qssm:flex-row flex-col">
        <div className="flex items-center w-auto gap-gap-sm">
          <SVGComponent
            url={ICONS?.CALENDER}
            color="var(--text-primary)"
            height="var(--icon-sm)"
            width="var(--icon-sm)"
          />

          <p
            className={` ${isRead ? "text-text-secondary" : "text-text-primary"} text-font-xs font-semibold flex items-center`}
          >
            {formatDateViewAll(notification?.delivered_at, true, true)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationPopupCard;
